import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header, SideBar } from '../../shared';
import { ContentBox } from '../Common/ContentBox';
import { LOCAL_STORAGE, ROUTES } from '../../../constants';
import { getLocalStorageItem } from '../../../utils';
import { useSelector } from 'react-redux';

export const AdminDashboard = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const role = useSelector((s) => s.user.role);
    const pathname = useMemo(
        () => location?.pathname || ROUTES.ADMIN.DASHBOARD,
        [location.pathname],
    );
    const [currentDashboardRoute, setCurrentDashboardRoute] = useState(pathname);
    const isCSMCaseload = getLocalStorageItem(LOCAL_STORAGE.IS_CSM_CASELOAD);

    useEffect(() => {
        if (!role) {
            navigate(ROUTES.ADMIN.LOGIN, { replace: true });
        }
        // redirect /admin to /admin/* if already logged in
        if (pathname === ROUTES.ADMIN.DEFAULT && role) {
            navigate(ROUTES.ADMIN.DASHBOARD, { replace: true });
        }
        setCurrentDashboardRoute(pathname);
    }, [role, navigate, pathname]);

    // Don’t render anything until auth check is resolved
    if (!role) return null;

    return (
        <>
            <Header isAdmin={true} />
            <main className={`${isCSMCaseload && 'isImpersonated'}`}>
                <div className='w-100 h-100 row mx-0 position-relative'>
                    <SideBar
                        sidebarFor='admin'
                        currentDashboardRoute={currentDashboardRoute}
                        setCurrentDashboardRoute={setCurrentDashboardRoute}
                    />
                    <ContentBox currentRoute={currentDashboardRoute} />
                </div>
            </main>
        </>
    );
};
